exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dot-badge[data-v-00a53183]{width:7px;height:7px;border-radius:100px;background:#eb394b;position:absolute;z-index:1}", ""]);

// exports
